import React from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <meta name="keywords" content="BookNDrive Privacy Policy" />
        <meta name="description" content="BookNDrive Privacy Policy" />
        <title>Privacy Policy | BookNDrive </title>
      </Helmet>
      <Header />
      <div className="container my-5">
        <p className="lead">
          At <strong>BookNDrive</strong>, we are committed to protecting the
          privacy of our users, including customers, car rental service users,
          and other visitors to our platform. This Privacy Policy outlines how
          we collect, use, disclose, and safeguard your information when you
          visit our platform. By using BookNDrive, you agree to the terms of
          this Privacy Policy.
        </p>
        <h2 className="mt-5">1. Information We Collect</h2>
        <p>
          We collect various types of information to provide and improve our
          services, including:
        </p>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>Personal Information:</strong> When you register as a user,
            we collect personal details such as your name, email address, phone
            number, delivery address, and payment information.
          </li>
          <li className="list-group-item">
            <strong>Booking Data:</strong> We collect details related to your
            car rental bookings, including rental dates, car preferences, and
            booking history.
          </li>
          <li className="list-group-item">
            <strong>Usage Data:</strong> Information about your interactions
            with our platform, such as pages visited, time spent on pages, IP
            address, and other diagnostic data.
          </li>
          <li className="list-group-item">
            <strong>Vehicle Information:</strong> Information about the vehicle
            you rent, such as make, model, and registration details.
          </li>
        </ul>
        <h2 className="mt-5">2. Use of Information</h2>
        <p>We use the collected information for the following purposes:</p>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>To Provide Services:</strong> Facilitate the car rental
            booking process, payment transactions, and customer support.
          </li>
          <li className="list-group-item">
            <strong>To Improve Our Platform:</strong> Analyze usage to enhance
            user experience, optimize the platform, and improve our services.
          </li>
          <li className="list-group-item">
            <strong>To Process Payments:</strong> Manage transactions and
            process payments via our integrated payment gateway.
          </li>
          <li className="list-group-item">
            <strong>To Communicate with Users:</strong> Send updates,
            promotional offers, and administrative information, such as updates
            to terms, privacy policies, and security alerts.
          </li>
        </ul>
        <h2 className="mt-5">3. Sharing of Information</h2>
        <p>
          We do not share your personal information with third parties except in
          the following circumstances:
        </p>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>Service Providers:</strong> We may share information with
            third-party service providers who assist in operating our platform,
            processing payments, and delivering services on our behalf.
          </li>
          <li className="list-group-item">
            <strong>Legal Requirements:</strong> If required by law or in
            response to valid requests by public authorities, such as a court or
            government agency.
          </li>
        </ul>
        <h2 className="mt-5">4. User Responsibilities</h2>
        <p>Users must:</p>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>Use the Platform Responsibly:</strong> Avoid sharing
            unnecessary personal information in public areas such as forums,
            comments, or reviews.
          </li>
          <li className="list-group-item">
            <strong>Respect Privacy:</strong> Not attempt to access or misuse
            others' personal data available on the platform.
          </li>
        </ul>
        <h2 className="mt-5">5. Security of Information</h2>
        <p>
          We implement appropriate technical and organizational measures to
          protect your personal information from unauthorized access,
          disclosure, alteration, and destruction. However, please be aware that
          no method of transmission over the Internet or electronic storage is
          100% secure, and we cannot guarantee absolute security.
        </p>
        <h2 className="mt-5">6. Your Data Protection Rights</h2>
        <p>You have the right to:</p>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>Access, Update, or Delete Information:</strong> Request
            access to your personal information or request updates or deletion
            of inaccurate data.
          </li>
          <li className="list-group-item">
            <strong>Withdraw Consent:</strong> If you have given consent for a
            specific purpose, you have the right to withdraw your consent at any
            time.
          </li>
        </ul>
        <h2 className="mt-5">7. Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date. You are advised
          to review this Privacy Policy periodically for any changes.
        </p>
        <h2 className="mt-5">8. Intellectual Property Rights</h2>
        <p>
          BookNDrive respects the intellectual property rights of others and
          adheres to trademark laws. Any mention of third-party trademarks on
          our platform, including but not limited to vehicle brands, is for
          identification purposes only and remains the property of their
          respective owners. We are not affiliated with, endorsed by, or
          certified by these organizations unless explicitly stated.
        </p>
        <h2 className="mt-5">9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:{" "}
          <a href="mailto:support@bookndrive.in">support@bookndrive.in</a>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
